module.exports = __webpack_public_path__ + "static/media/info_circle_icon.de38db88.svg";